// extracted by mini-css-extract-plugin
export default {"input":"S8-z","button":"T8-z","selected":"U8-z","unavailable":"V8-z","oos":"W8-z","image":"X8-z","paperCutDisabledOverlay":"Y8-z"};